import React from 'react'
import { observer, inject } from 'mobx-react'
import { ScaleSymLog, ScaleLinear } from 'd3-scale'
import { line } from 'd3-shape'
import { StateType } from '../state/state'
import { ARROW_MARKER_ID } from '../constants'
import { DatumWithCoords } from '../types'
import { sortBy } from 'lodash-es'

interface Props {
  className?: string
  state?: StateType
  xScale: ScaleSymLog<number, number> | ScaleLinear<number, number>
  yScale: ScaleSymLog<number, number> | ScaleLinear<number, number>
  [x: string]: any
}

export const Paths: React.FC<Props> = inject('state')(
  observer(({ className = '', state, xScale, yScale, ...props }) => {
    const { paths, isCountryActive } = state.ScatterplotState

    const lineGenerator = line<DatumWithCoords>()
      .x((d) => xScale(d.x))
      .y((d) => yScale(d.y))

    return (
      <g className={`-paths ${className}`} {...props}>
        {paths.map(({ country, pathPoints }) => {
          const d = lineGenerator(sortBy(pathPoints, 'year'))

          return (
            <path
              key={country}
              className={`-path-${country}`}
              d={d}
              stroke="black"
              strokeOpacity={isCountryActive(country) ? 0.6 : 0.4}
              strokeWidth={1}
              fill="none"
              markerEnd={`url(#${ARROW_MARKER_ID})`}
            />
          )
        })}
      </g>
    )
  })
)
